// import React from 'react';
// import Spacing from '../Spacing';
// import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
// import { Icon } from '@iconify/react';
// import { pageTitle } from '../../helpers/PageTitle';

// export default function BrandIdentityDesign() {
//   pageTitle('Portfolio Details');
//   return (
//     <>
//       <Spacing lg="70" md="70" />
//       <Spacing lg="140" md="80" />
//       <SectionHeadingStyle3
//         title="Drip-Soaked Brand Artistry"
//         subTitle="Brand Identity Design"
//       />
//       <Spacing lg="75" md="60" />
//       <div className="container">
//         <div className="cs_portfolio_details">
//           <img src="/images/brandID2.jpg" alt="Thumb" />
//           <Spacing lg="100" md="40" />
//           <div className="cs_portfolio_details_in">
//             <ul className="cs_portfolio_details_info cs_mp0">
//               <li>
//                 <h3 className="cs_fs_21 mb-0 cs_semibold">Client:</h3>
//                 <p className="mb-0">Andrew romania</p>
//               </li>
//               <li>
//                 <h3 className="cs_fs_21 mb-0 cs_semibold">Location:</h3>
//                 <p className="mb-0">United Kindom</p>
//               </li>
//               <li>
//                 <h3 className="cs_fs_21 mb-0 cs_semibold">Budget:</h3>
//                 <p className="mb-0">$2500</p>
//               </li>
//               <li>
//                 <h3 className="cs_fs_21 mb-0 cs_semibold">
//                   Project Completed:
//                 </h3>
//                 <p className="mb-0">11 August,2022</p>
//               </li>
//             </ul>
//             <div className="cs_portfolio_details_right">
//               <h2>Project Summary</h2>
//               <p>
//                 Colorfullll artwork is a creative project that aims to explore the
//                 beauty and diversity of colorful artwork. The project seeks to
//                 showcase the myriad of ways in which colors can be used to
//                 convey emotions, ideas, and expressions in the world of art.
//                 <br />
//                 The project will feature a collection of artworks created by
//                 talented artists from different parts of the world. Each artwork
//                 will be selected based on its unique use of color, and how it
//                 contributes to the overall composition of the piece. The project
//                 will feature a diverse range of art forms, including paintings,
//                 drawings, digital art, and mixed media.
//               </p>
//               <p>
//                 Through this project, we aim to celebrate the power of color in
//                 art, and how it can be used to convey a wide range of emotions
//                 and meanings. We hope to inspire a deeper appreciation of art
//                 and its ability to connect with people on a visceral level. In
//                 addition to the artwork, the project will also feature
//                 interviews with the artists, where they will discuss their
//                 inspiration, creative process, and their use of color in their
//                 art. This will provide a unique insight into the creative minds
//                 of the artists and help the audience understand the meaning and
//                 symbolism behind their art.
//               </p>
//             </div>
//           </div>
//           <Spacing lg="115" md="60" />
//           <div className="cs_portfolio_details_gallery">
//             <div>
//               <img src="/images/brandID1.jpg" alt="Thumb" />
//             </div>
//             <div>
//               <img src="/images/brandID3.png" alt="Thumb" />
//             </div>
//             <div>
//               <img src="/images/brandID4.png" alt="Thumb" />
//             </div>
//           </div>
//         </div>
//         <Spacing lg="90" md="60" />
//         <div className="cs_page_navigation cs_center">
//           <div>
//             <a href="/" className="cs_text_btn cs_type1">
//               <Icon icon="cil:arrow-left" className="cs_fs_21" />
//               <span>Prev Project</span>
//             </a>
//           </div>
//           <div>
//             <a href="/" className="cs_text_btn">
//               <span>Next Project</span>
//               <Icon icon="cil:arrow-right" className="cs_fs_21" />
//             </a>
//           </div>
//         </div>
//       </div>
//       <Spacing lg="150" md="80" />
//     </>
//   );
// }




//  {/* <div className="cs_page_navigation cs_center">
//           <div>
//             <button
//               onClick={handlePrev}
//               className="cs_text_btn cs_type1"
//               disabled={currentIndex === 0}
//             >
//               <Icon icon="cil:arrow-left" className="cs_fs_21" />
//               <span>Prev Project</span>
//             </button>
//           </div>
//           <div>
//             <button
//               onClick={handleNext}
//               className="cs_text_btn"
//               disabled={currentIndex === brandData.length - 1}
//             >
//               <span >Next Project</span>
//               <Icon icon="cil:arrow-right" className="cs_fs_21" />
//             </button>
//           </div>
//         </div> */}


//---------------

//working final
// import React, { useState } from 'react';
// import Spacing from '../Spacing';
// import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
// import { Icon } from '@iconify/react';
// import { pageTitle } from '../../helpers/PageTitle';

// const brandData = [
//   {
//     title: 'Drip-Soaked Brand Artistry',
//     subTitle: 'Brand Identity Design',
//     client: 'Pepe Jeans',
//     location: 'India',
//     budget: 'Logo Design',
//     date: '15-20 Days',
//     summary: [
//       `For the iconic fashion label Pepe Jeans, our task was to reimagine their logo with a bold, modern edge—one that speaks to both heritage and the fast-evolving streetwear culture. Brandgazm approached this challenge by blending deep brand immersion with strategic visual design.

// We retained the rebellious spirit of the brand while introducing sharper lines and adaptable geometry, ensuring the logo holds strong across everything from denim tags to billboards. Our creative process involved mood-mapping subcultures, testing visibility across textile textures, and building a symbol that’s instantly recognizable yet refreshingly contemporary.

// The result? A logo that doesn’t just sit on a label—it leads a movement..`,
//     ],
//     mainImage: '/images/pepe.jpg',
//     gallery: [
//       '/images/brandID1.png',
//       '/images/brandID3.jpg',
//       '/images/brandID4.png',
//       '/images/brandID6.png',
//       '/images/brandID5.png',
//     ],
//   },
//   {
//     title: 'The Digital Fame Starter Kit',
//     subTitle: 'Digital Branding Pack',
//     client: 'Vish Fashion',
//     location: 'United Kingdom',
//     budget: 'Digital Branding',
//     date: '10-15 Days',
//     summary: [
//       `We collaborated with VISH, an emerging streetwear fashion brand, to develop a comprehensive digital visual system that reflects their bold and modern ethos. The scope included designing product tags, branded clothing elements, and a suite of social media content tailored for high engagement and consistent brand expression.

// Our approach was rooted in capturing the raw energy of street culture while ensuring a refined, scalable visual identity. Every design touchpoint — from texture and typography to layout and tone — was crafted to maintain brand coherence across digital and physical platforms.`,
//     ],
//     mainImage: '/images/vishID1.png',
//     gallery: [
//       '/images/vishID2.png',
//       '/images/vishID4.png',
//       '/images/vishID6.png',
//       '/images/vishID5.png',
//       '/images/vishID3.png',
//       '/images/vishID7.png',
//     ],
//   },
//   {
//     title: 'Showcase Your Brand with Professional Brochures',
//     subTitle: 'Brochure Design',
//     client: 'Go Mechanic',
//     location: 'India',
//     budget: 'Brochure Design',
//     date: '3-5 Days',
//     summary: [
//       `For GoMechanic, a fast-growing automotive service brand, we were entrusted with creating a high-impact brochure that not only informs but also converts. Our challenge was to design a print and digital-ready collateral that could distill complex service offerings into a sleek, engaging, and easy-to-navigate format.

// We strategically structured the layout to guide readers through their value propositions, backed by clear typography, minimal yet bold visuals, and smart content hierarchy. Each section was purpose-built to drive action`,
//     ],
//     mainImage: '/images/goID1.png',
//     gallery: [
//       '/images/goID2.png',
//       '/images/goID4.png',
//       '/images/goID6.png',
//       '/images/goID3.png',
//       '/images/goID5.png',
//       '/images/goID7.png',
//     ],
//   },
//   {
//     title: 'Scroll-Stopping Designs with <br/> a Splash of Fun',
//     subTitle: 'Social Media Content',
//     client: 'NA',
//     location: 'Global',
//     budget: 'Social Media Posts',
//     date: 'Retainer',
//     summary: [
//       `For social media campaigns, we designed visually appealing posts showcasing the product’s features with clarity and style. The concept included humorously comparing the product to competitors, using witty and playful ads that stood out and engaged the audience effectively. We also created beautifully crafted carousel posts that combined creative visuals and concise messaging to tell compelling brand stories. Beyond this, our expertise spans across diverse social media post designs, including promotional graphics, event announcements, and brand storytelling, all tailored to boost engagement and strengthen brand presence.

// `,
//     ],
//     mainImage: '/images/socialID.jpg',
//     gallery: [
//       '/images/social02.jpg',
//       '/images/social03.png',
//       '/images/social04.png',
//       '/images/social05.png',
//       '/images/social06.jpg',
//     ],
//   },
//   // Add more project objects as needed
// ];

// export default function BrandIdentityDesign() {
//   pageTitle('Portfolio Details');
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const project = brandData[currentIndex];


//   const handleNext = () => {
//     if (currentIndex < brandData.length - 1) {
//       setCurrentIndex(prev => prev + 1);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   };

//   const handlePrev = () => {
//     if (currentIndex > 0) {
//       setCurrentIndex(prev => prev - 1);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   };


//   return (
//     <>
//       <Spacing lg="70" md="70" />
//       <Spacing lg="140" md="80" />
//       <SectionHeadingStyle3 title={project.title} subTitle={project.subTitle} />
//       <Spacing lg="75" md="60" />
//       <div className="container">
//         <div className="cs_portfolio_details">
//           <img src={project.mainImage} alt="Thumb" />
//           <Spacing lg="100" md="40" />
//           <div className="cs_portfolio_details_in">
//             <ul className="cs_portfolio_details_info cs_mp0">
//               <li>
//                 <h3 className="cs_fs_21 mb-0 cs_semibold">Client:</h3>
//                 <p className="mb-0">{project.client}</p>
//               </li>
//               <li>
//                 <h3 className="cs_fs_21 mb-0 cs_semibold">Location:</h3>
//                 <p className="mb-0">{project.location}</p>
//               </li>
//               <li>
//                 <h3 className="cs_fs_21 mb-0 cs_semibold">Work:</h3>
//                 <p className="mb-0">{project.budget}</p>
//               </li>
//               <li>
//                 <h3 className="cs_fs_21 mb-0 cs_semibold">Project Duration:</h3>
//                 <p className="mb-0">{project.date}</p>
//               </li>
//             </ul>
//             <div className="cs_portfolio_details_right">
//               <h2>Project Summary</h2>
//               {project.summary.map((text, i) => (
//                 <p key={i}>{text}</p>
//               ))}
//             </div>
//           </div>
//           <Spacing lg="115" md="60" />
//           <div className="cs_portfolio_details_gallery">
//             {project.gallery.map((img, i) => (
//               <div key={i}>
//                 <img src={img} alt={`Gallery ${i + 1}`} />
//               </div>
//             ))}
//           </div>
//         </div>
//         <Spacing lg="90" md="60" />

//         <div className="cs_page_navigation cs_center">
//           <div>
//             <button
//               type="button"
//               onClick={handlePrev}
//               className={`cs_text_btn cs_type1 ${currentIndex === 0 ? 'cs_disabled' : ''}`}
//               disabled={currentIndex === 0}
//               style={{ all: 'unset', cursor: currentIndex === 0 ? 'not-allowed' : 'pointer' }}
//             >
//               <Icon icon="cil:arrow-left" className="cs_fs_21" />
//               <span>Prev Project</span>
//             </button>
//           </div>
//           <div>
//             <button
//               type="button"
//               onClick={handleNext}
//               className={`cs_text_btn ${currentIndex === brandData.length - 1 ? 'cs_disabled' : ''}`}
//               disabled={currentIndex === brandData.length - 1}
//               style={{ all: 'unset', cursor: currentIndex === brandData.length - 1 ? 'not-allowed' : 'pointer' }}
//             >
//               <span>Next Project</span>
//               <Icon icon="cil:arrow-right" className="cs_fs_21" />
//             </button>
//           </div>
//         </div>

//       </div>
//       <Spacing lg="150" md="80" />
//     </>
//   );
// }


//-----------------
// import React, { useState } from 'react';
// import Spacing from '../Spacing';
// import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
// import { Icon } from '@iconify/react';
// import { pageTitle } from '../../helpers/PageTitle';

// const brandData = [
//   {
//     title: 'Drip-Soaked Brand Artistry',
//     subTitle: 'Brand Identity Design',
//     client: 'Pepe Jeans',
//     location: 'India',
//     budget: 'Logo Design',
//     date: '15-20 Days',
//     summary: [
//       `For the iconic fashion label Pepe Jeans, our task was to reimagine their logo with a bold, modern edge—one that speaks to both heritage and the fast-evolving streetwear culture. Brandgazm approached this challenge by blending deep brand immersion with strategic visual design.

// We retained the rebellious spirit of the brand while introducing sharper lines and adaptable geometry, ensuring the logo holds strong across everything from denim tags to billboards. Our creative process involved mood-mapping subcultures, testing visibility across textile textures, and building a symbol that’s instantly recognizable yet refreshingly contemporary.

// The result? A logo that doesn’t just sit on a label—it leads a movement..`,
//     ],
//     mainImage: '/images/pepe.jpg',
//     gallery: [
//       '/images/brandID1.png',
//       '/images/brandID3.jpg',
//       '/images/brandID4.png',
//       '/images/brandID6.png',
//       '/images/brandID5.png',
//     ],
//   },
//   {
//     title: 'The Digital Fame Starter Kit',
//     subTitle: 'Digital Branding Pack',
//     client: 'Vish Fashion',
//     location: 'United Kingdom',
//     budget: 'Digital Branding',
//     date: '10-15 Days',
//     summary: [
//       `We collaborated with VISH, an emerging streetwear fashion brand, to develop a comprehensive digital visual system that reflects their bold and modern ethos. The scope included designing product tags, branded clothing elements, and a suite of social media content tailored for high engagement and consistent brand expression.

// Our approach was rooted in capturing the raw energy of street culture while ensuring a refined, scalable visual identity. Every design touchpoint — from texture and typography to layout and tone — was crafted to maintain brand coherence across digital and physical platforms.`,
//     ],
//     mainImage: '/images/vishID1.png',
//     gallery: [
//       '/images/vishID2.png',
//       '/images/vishID4.png',
//       '/images/vishID6.png',
//       '/images/vishID5.png',
//       '/images/vishID3.png',
//       '/images/vishID7.png',
//     ],
//   },
//   {
//     title: 'Showcase Your Brand with Professional Brochures',
//     subTitle: 'Brochure Design',
//     client: 'Go Mechanic',
//     location: 'India',
//     budget: 'Brochure Design',
//     date: '3-5 Days',
//     summary: [
//       `For GoMechanic, a fast-growing automotive service brand, we were entrusted with creating a high-impact brochure that not only informs but also converts. Our challenge was to design a print and digital-ready collateral that could distill complex service offerings into a sleek, engaging, and easy-to-navigate format.

// We strategically structured the layout to guide readers through their value propositions, backed by clear typography, minimal yet bold visuals, and smart content hierarchy. Each section was purpose-built to drive action`,
//     ],
//     mainImage: '/images/goID1.png',
//     gallery: [
//       '/images/goID2.png',
//       '/images/goID4.png',
//       '/images/goID6.png',
//       '/images/goID3.png',
//       '/images/goID5.png',
//       '/images/goID7.png',
//     ],
//   },
//   {
//     title: 'Scroll-Stopping Designs with <br/> a Splash of Fun',
//     subTitle: 'Social Media Content',
//     client: 'NA',
//     location: 'Global',
//     budget: 'Social Media Posts',
//     date: 'Retainer',
//     summary: [
//       `For social media campaigns, we designed visually appealing posts showcasing the product’s features with clarity and style. The concept included humorously comparing the product to competitors, using witty and playful ads that stood out and engaged the audience effectively. We also created beautifully crafted carousel posts that combined creative visuals and concise messaging to tell compelling brand stories. Beyond this, our expertise spans across diverse social media post designs, including promotional graphics, event announcements, and brand storytelling, all tailored to boost engagement and strengthen brand presence.

// `,
//     ],
//     mainImage: '/images/socialID.jpg',
//     gallery: [
//       '/images/social02.jpg',
//       '/images/social03.png',
//       '/images/social04.png',
//       '/images/social05.png',
//       '/images/social06.jpg',
//     ],
//   },
//   // Add more project objects as needed
// ];

// export default function BrandIdentityDesign() {
//   pageTitle('Portfolio Details');
//   const [currentIndex, setCurrentIndex] = useState(0);
//   // const [currentIndex, setCurrentIndex] = useState(0);
//   const [isTransitioning, setIsTransitioning] = useState(false);
//   const [direction, setDirection] = useState('next');

//   // const project = brandData[currentIndex];

//   const project = brandData[currentIndex];


//   // const handleNext = () => {
//   //   if (currentIndex < brandData.length - 1) {
//   //     setIsTransitioning(true);
//   //     setTimeout(() => {
//   //       setCurrentIndex(prev => prev + 1);
//   //       window.scrollTo({ top: 0, behavior: 'smooth' });
//   //       setIsTransitioning(false);
//   //     }, 400); // match this with CSS transition duration
//   //   }
//   // };

//   // const handlePrev = () => {
//   //   if (currentIndex > 0) {
//   //     setIsTransitioning(true);
//   //     setTimeout(() => {
//   //       setCurrentIndex(prev => prev - 1);
//   //       window.scrollTo({ top: 0, behavior: 'smooth' });
//   //       setIsTransitioning(false);
//   //     }, 400);
//   //   }
//   // };
//   const handleNext = () => {
//     if (currentIndex < brandData.length - 1) {
//       setDirection('next');
//       setIsTransitioning(true);
//       setTimeout(() => {
//         setCurrentIndex(prev => prev + 1);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//         setIsTransitioning(false);
//       }, 500);
//     }
//   };
  
//   const handlePrev = () => {
//     if (currentIndex > 0) {
//       setDirection('prev');
//       setIsTransitioning(true);
//       setTimeout(() => {
//         setCurrentIndex(prev => prev - 1);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//         setIsTransitioning(false);
//       }, 500);
//     }
//   };
  



//   return (
//     <>

//       {/* <div className={`project-transition-wrapper ${isTransitioning ? 'fade-out' : 'fade-in'}`}> */}
//       <div className={`project-transition-wrapper ${isTransitioning ? (direction === 'next' ? 'slide-left' : 'slide-right') : 'slide-in'}`}>


//         <Spacing lg="70" md="70" />
//         <Spacing lg="140" md="80" />
//         <SectionHeadingStyle3 title={project.title} subTitle={project.subTitle} />
//         <Spacing lg="75" md="60" />
//         <div className="container">
//           <div className="cs_portfolio_details">
//             <img src={project.mainImage} alt="Thumb" />
//             <Spacing lg="100" md="40" />
//             <div className="cs_portfolio_details_in">
//               <ul className="cs_portfolio_details_info cs_mp0">
//                 <li>
//                   <h3 className="cs_fs_21 mb-0 cs_semibold">Client:</h3>
//                   <p className="mb-0">{project.client}</p>
//                 </li>
//                 <li>
//                   <h3 className="cs_fs_21 mb-0 cs_semibold">Location:</h3>
//                   <p className="mb-0">{project.location}</p>
//                 </li>
//                 <li>
//                   <h3 className="cs_fs_21 mb-0 cs_semibold">Work:</h3>
//                   <p className="mb-0">{project.budget}</p>
//                 </li>
//                 <li>
//                   <h3 className="cs_fs_21 mb-0 cs_semibold">Project Duration:</h3>
//                   <p className="mb-0">{project.date}</p>
//                 </li>
//               </ul>
//               <div className="cs_portfolio_details_right">
//                 <h2>Project Summary</h2>
//                 {project.summary.map((text, i) => (
//                   <p key={i}>{text}</p>
//                 ))}
//               </div>
//             </div>
//             <Spacing lg="115" md="60" />
//             <div className="cs_portfolio_details_gallery">
//               {project.gallery.map((img, i) => (
//                 <div key={i}>
//                   <img src={img} alt={`Gallery ${i + 1}`} />
//                 </div>
//               ))}
//             </div>
//           </div>
//           <Spacing lg="90" md="60" />

//           <div className="cs_page_navigation cs_center">
//             <div>
//               <button
//                 type="button"
//                 onClick={handlePrev}
//                 className={`cs_text_btn cs_type1 ${currentIndex === 0 ? 'cs_disabled' : ''}`}
//                 disabled={currentIndex === 0}
//                 style={{ all: 'unset', cursor: currentIndex === 0 ? 'not-allowed' : 'pointer' }}
//               >
//                 <Icon icon="cil:arrow-left" className="cs_fs_21" />
//                 <span>Prev Project</span>
//               </button>
//             </div>
//             <div>
//               <button
//                 type="button"
//                 onClick={handleNext}
//                 className={`cs_text_btn ${currentIndex === brandData.length - 1 ? 'cs_disabled' : ''}`}
//                 disabled={currentIndex === brandData.length - 1}
//                 style={{ all: 'unset', cursor: currentIndex === brandData.length - 1 ? 'not-allowed' : 'pointer' }}
//               >
//                 <span>Next Project</span>
//                 <Icon icon="cil:arrow-right" className="cs_fs_21" />
//               </button>
//             </div>
//           </div>

//         </div>
//         <Spacing lg="150" md="80" />
//       </div>

//       <style jsx>{`
//                 .project-transition-wrapper {
//             transition: opacity 0.4s ease-in-out;
//           }

//           .fade-out {
//             opacity: 0;
//             pointer-events: none;
//           }

//           .fade-in {
//             opacity: 1;
//           }

//                     .project-transition-wrapper {
//             transition: all 0.5s ease-in-out;
//             opacity: 1;
//             transform: translateX(0);
//           }

//           .slide-left {
//             opacity: 0;
//             transform: translateX(-50px);
//           }

//           .slide-right {
//             opacity: 0;
//             transform: translateX(50px);
//           }

//           .slide-in {
//             opacity: 1;
//             transform: translateX(0);
//           }


//       `}</style>

//     </>


//   );
// }


//------------

// import React, { useState } from 'react';
// import Spacing from '../Spacing';
// import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
// import { Icon } from '@iconify/react';
// import { pageTitle } from '../../helpers/PageTitle';

// const brandData = [
//   {
//     title: 'Drip-Soaked Brand Artistry',
//     subTitle: 'Brand Identity Design',
//     client: 'Pepe Jeans',
//     location: 'India',
//     budget: 'Logo Design',
//     date: '15-20 Days',
//     summary: [
//       `For the iconic fashion label Pepe Jeans, our task was to reimagine their logo with a bold, modern edge—one that speaks to both heritage and the fast-evolving streetwear culture. Brandgazm approached this challenge by blending deep brand immersion with strategic visual design.

// We retained the rebellious spirit of the brand while introducing sharper lines and adaptable geometry, ensuring the logo holds strong across everything from denim tags to billboards. Our creative process involved mood-mapping subcultures, testing visibility across textile textures, and building a symbol that’s instantly recognizable yet refreshingly contemporary.

// The result? A logo that doesn’t just sit on a label—it leads a movement..`,
//     ],
//     mainImage: '/images/pepe.jpg',
//     gallery: [
//       '/images/brandID1.png',
//       '/images/brandID3.jpg',
//       '/images/brandID4.png',
//       '/images/brandID6.png',
//       '/images/brandID5.png',
//     ],
//   },
//   {
//     title: 'The Digital Fame Starter Kit',
//     subTitle: 'Digital Branding Pack',
//     client: 'Vish Fashion',
//     location: 'United Kingdom',
//     budget: 'Digital Branding',
//     date: '10-15 Days',
//     summary: [
//       `We collaborated with VISH, an emerging streetwear fashion brand, to develop a comprehensive digital visual system that reflects their bold and modern ethos. The scope included designing product tags, branded clothing elements, and a suite of social media content tailored for high engagement and consistent brand expression.

// Our approach was rooted in capturing the raw energy of street culture while ensuring a refined, scalable visual identity. Every design touchpoint — from texture and typography to layout and tone — was crafted to maintain brand coherence across digital and physical platforms.`,
//     ],
//     mainImage: '/images/vishID1.png',
//     gallery: [
//       '/images/vishID2.png',
//       '/images/vishID4.png',
//       '/images/vishID6.png',
//       '/images/vishID5.png',
//       '/images/vishID3.png',
//       '/images/vishID7.png',
//     ],
//   },
//   {
//     title: 'Showcase Your Brand with Professional Brochures',
//     subTitle: 'Brochure Design',
//     client: 'Go Mechanic',
//     location: 'India',
//     budget: 'Brochure Design',
//     date: '3-5 Days',
//     summary: [
//       `For GoMechanic, a fast-growing automotive service brand, we were entrusted with creating a high-impact brochure that not only informs but also converts. Our challenge was to design a print and digital-ready collateral that could distill complex service offerings into a sleek, engaging, and easy-to-navigate format.

// We strategically structured the layout to guide readers through their value propositions, backed by clear typography, minimal yet bold visuals, and smart content hierarchy. Each section was purpose-built to drive action`,
//     ],
//     mainImage: '/images/goID1.png',
//     gallery: [
//       '/images/goID2.png',
//       '/images/goID4.png',
//       '/images/goID6.png',
//       '/images/goID3.png',
//       '/images/goID5.png',
//       '/images/goID7.png',
//     ],
//   },
//   {
//     title: 'Scroll-Stopping Designs with <br/> a Splash of Fun',
//     subTitle: 'Social Media Content',
//     client: 'NA',
//     location: 'Global',
//     budget: 'Social Media Posts',
//     date: 'Retainer',
//     summary: [
//       `For social media campaigns, we designed visually appealing posts showcasing the product’s features with clarity and style. The concept included humorously comparing the product to competitors, using witty and playful ads that stood out and engaged the audience effectively. We also created beautifully crafted carousel posts that combined creative visuals and concise messaging to tell compelling brand stories. Beyond this, our expertise spans across diverse social media post designs, including promotional graphics, event announcements, and brand storytelling, all tailored to boost engagement and strengthen brand presence.

// `,
//     ],
//     mainImage: '/images/socialID.jpg',
//     gallery: [
//       '/images/social02.jpg',
//       '/images/social03.png',
//       '/images/social04.png',
//       '/images/social05.png',
//       '/images/social06.jpg',
//     ],
//   },
//   // Add more project objects as needed
// ];

// export default function BrandIdentityDesign() {
//   pageTitle('Portfolio Details');
//   const [currentIndex, setCurrentIndex] = useState(0);
//   // const [currentIndex, setCurrentIndex] = useState(0);
//   const [isTransitioning, setIsTransitioning] = useState(false);
//   const [direction, setDirection] = useState('next');

//   // const project = brandData[currentIndex];

//   const project = brandData[currentIndex];


//   // const handleNext = () => {
//   //   if (currentIndex < brandData.length - 1) {
//   //     setIsTransitioning(true);
//   //     setTimeout(() => {
//   //       setCurrentIndex(prev => prev + 1);
//   //       window.scrollTo({ top: 0, behavior: 'smooth' });
//   //       setIsTransitioning(false);
//   //     }, 400); // match this with CSS transition duration
//   //   }
//   // };

//   // const handlePrev = () => {
//   //   if (currentIndex > 0) {
//   //     setIsTransitioning(true);
//   //     setTimeout(() => {
//   //       setCurrentIndex(prev => prev - 1);
//   //       window.scrollTo({ top: 0, behavior: 'smooth' });
//   //       setIsTransitioning(false);
//   //     }, 400);
//   //   }
//   // };
//   const handleNext = () => {
//     if (currentIndex < brandData.length - 1) {
//       setDirection('next');
//       setIsTransitioning(true);
//       setTimeout(() => {
//         setCurrentIndex(prev => prev + 1);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//         setIsTransitioning(false);
//       }, 500);
//     }
//   };
  
//   const handlePrev = () => {
//     if (currentIndex > 0) {
//       setDirection('prev');
//       setIsTransitioning(true);
//       setTimeout(() => {
//         setCurrentIndex(prev => prev - 1);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//         setIsTransitioning(false);
//       }, 500);
//     }
//   };
  



//   return (
//     <>

//       {/* <div className={`project-transition-wrapper ${isTransitioning ? 'fade-out' : 'fade-in'}`}> */}
//       <div className={`project-transition-wrapper ${isTransitioning ? (direction === 'next' ? 'slide-left' : 'slide-right') : 'slide-in'}`}>


//         <Spacing lg="70" md="70" />
//         <Spacing lg="140" md="80" />
//         <SectionHeadingStyle3 title={project.title} subTitle={project.subTitle} />
//         <Spacing lg="75" md="60" />
//         <div className="container">
//           <div className="cs_portfolio_details">
//             <img src={project.mainImage} alt="Thumb" />
//             <Spacing lg="100" md="40" />
//             <div className="cs_portfolio_details_in">
//               <ul className="cs_portfolio_details_info cs_mp0">
//                 <li>
//                   <h3 className="cs_fs_21 mb-0 cs_semibold">Client:</h3>
//                   <p className="mb-0">{project.client}</p>
//                 </li>
//                 <li>
//                   <h3 className="cs_fs_21 mb-0 cs_semibold">Location:</h3>
//                   <p className="mb-0">{project.location}</p>
//                 </li>
//                 <li>
//                   <h3 className="cs_fs_21 mb-0 cs_semibold">Work:</h3>
//                   <p className="mb-0">{project.budget}</p>
//                 </li>
//                 <li>
//                   <h3 className="cs_fs_21 mb-0 cs_semibold">Project Duration:</h3>
//                   <p className="mb-0">{project.date}</p>
//                 </li>
//               </ul>
//               <div className="cs_portfolio_details_right">
//                 <h2>Project Summary</h2>
//                 {project.summary.map((text, i) => (
//                   <p key={i}>{text}</p>
//                 ))}
//               </div>
//             </div>
//             <Spacing lg="115" md="60" />
//             <div className="cs_portfolio_details_gallery">
//               {project.gallery.map((img, i) => (
//                 <div key={i}>
//                   <img src={img} alt={`Gallery ${i + 1}`} />
//                 </div>
//               ))}
//             </div>
//           </div>
//           <Spacing lg="90" md="60" />

//           <div className="cs_page_navigation cs_center">
//             <div>
//               <button
//                 type="button"
//                 onClick={handlePrev}
//                 className={`cs_text_btn cs_type1 ${currentIndex === 0 ? 'cs_disabled' : ''}`}
//                 disabled={currentIndex === 0}
//                 style={{ all: 'unset', cursor: currentIndex === 0 ? 'not-allowed' : 'pointer' }}
//               >
//                 <Icon icon="cil:arrow-left" className="cs_fs_21" />
//                 <span>Prev Project</span>
//               </button>
//             </div>
//             <div>
//               <button
//                 type="button"
//                 onClick={handleNext}
//                 className={`cs_text_btn ${currentIndex === brandData.length - 1 ? 'cs_disabled' : ''}`}
//                 disabled={currentIndex === brandData.length - 1}
//                 style={{ all: 'unset', cursor: currentIndex === brandData.length - 1 ? 'not-allowed' : 'pointer' }}
//               >
//                 <span>Next Project</span>
//                 <Icon icon="cil:arrow-right" className="cs_fs_21" />
//               </button>
//             </div>
//           </div>

//         </div>
//         <Spacing lg="150" md="80" />
//       </div>

//       <style jsx>{`
//                 .project-transition-wrapper {
//             transition: opacity 0.4s ease-in-out;
//           }

//           .fade-out {
//             opacity: 0;
//             pointer-events: none;
//           }

//           .fade-in {
//             opacity: 1;
//           }

//                     .project-transition-wrapper {
//             transition: all 0.5s ease-in-out;
//             opacity: 1;
//             transform: translateX(0);
//           }

//           .slide-left {
//             opacity: 0;
//             transform: translateX(-50px);
//           }

//           .slide-right {
//             opacity: 0;
//             transform: translateX(50px);
//           }

//           .slide-in {
//             opacity: 1;
//             transform: translateX(0);
//           }


//       `}</style>

//     </>


//   );
// }


//-----------

import React, { useState } from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import { pageTitle } from '../../helpers/PageTitle';
import { useEffect, useRef } from 'react';


const brandData = [
  {
    title: 'Drip-Soaked Brand Artistry',
    subTitle: 'Brand Identity Design',
    client: 'Pepe Jeans',
    location: 'India',
    budget: 'Logo Design',
    date: '15-20 Days',
    summary: [
      `For the iconic fashion label Pepe Jeans, our task was to reimagine their logo with a bold, modern edge—one that speaks to both heritage and the fast-evolving streetwear culture. Brandgazm approached this challenge by blending deep brand immersion with strategic visual design.

We retained the rebellious spirit of the brand while introducing sharper lines and adaptable geometry, ensuring the logo holds strong across everything from denim tags to billboards. Our creative process involved mood-mapping subcultures, testing visibility across textile textures, and building a symbol that’s instantly recognizable yet refreshingly contemporary.

The result? A logo that doesn’t just sit on a label—it leads a movement..`,
    ],
    mainImage: '/images/pepe.jpg',
    gallery: [
      '/images/brandID1.png',
      '/images/brandID3.jpg',
      '/images/brandID4.png',
      '/images/brandID6.png',
      '/images/brandID5.png',
    ],
  },
  {
    title: 'The Digital Fame Starter Kit',
    subTitle: 'Digital Branding Pack',
    client: 'Vish Fashion',
    location: 'United Kingdom',
    budget: 'Digital Branding',
    date: '10-15 Days',
    summary: [
      `We collaborated with VISH, an emerging streetwear fashion brand, to develop a comprehensive digital visual system that reflects their bold and modern ethos. The scope included designing product tags, branded clothing elements, and a suite of social media content tailored for high engagement and consistent brand expression.

Our approach was rooted in capturing the raw energy of street culture while ensuring a refined, scalable visual identity. Every design touchpoint — from texture and typography to layout and tone — was crafted to maintain brand coherence across digital and physical platforms.`,
    ],
    mainImage: '/images/vishID1.png',
    gallery: [
      '/images/vishID2.png',
      '/images/vishID4.png',
      '/images/vishID6.png',
      '/images/vishID5.png',
      '/images/vishID3.png',
      '/images/vishID7.png',
    ],
  },
  {
    title: 'Showcase Your Brand with Professional Brochures',
    subTitle: 'Brochure Design',
    client: 'Go Mechanic',
    location: 'India',
    budget: 'Brochure Design',
    date: '3-5 Days',
    summary: [
      `For GoMechanic, a fast-growing automotive service brand, we were entrusted with creating a high-impact brochure that not only informs but also converts. Our challenge was to design a print and digital-ready collateral that could distill complex service offerings into a sleek, engaging, and easy-to-navigate format.

We strategically structured the layout to guide readers through their value propositions, backed by clear typography, minimal yet bold visuals, and smart content hierarchy. Each section was purpose-built to drive action`,
    ],
    mainImage: '/images/goID1.png',
    gallery: [
      '/images/goID2.png',
      '/images/goID4.png',
      '/images/goID6.png',
      '/images/goID3.png',
      '/images/goID5.png',
      '/images/goID7.png',
    ],
  },
  {
    title: 'Scroll-Stopping Designs with <br/> a Splash of Fun',
    subTitle: 'Social Media Content',
    client: 'NA',
    location: 'Global',
    budget: 'Social Media Posts',
    date: 'Retainer',
    summary: [
      `For social media campaigns, we designed visually appealing posts showcasing the product’s features with clarity and style. The concept included humorously comparing the product to competitors, using witty and playful ads that stood out and engaged the audience effectively. We also created beautifully crafted carousel posts that combined creative visuals and concise messaging to tell compelling brand stories. Beyond this, our expertise spans across diverse social media post designs, including promotional graphics, event announcements, and brand storytelling, all tailored to boost engagement and strengthen brand presence.

`,
    ],
    mainImage: '/images/socialID.jpg',
    gallery: [
      '/images/social02.jpg',
      '/images/social03.png',
      '/images/social04.png',
      '/images/social05.png',
      '/images/social06.jpg',
    ],
  },
  // Add more project objects as needed
];

export default function BrandIdentityDesign() {
  const wrapperRef = useRef(null);

  pageTitle('Portfolio Details');
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [direction, setDirection] = useState('next');

  // const project = brandData[currentIndex];

  const project = brandData[currentIndex];


  const handleNext = () => {
    if (currentIndex < brandData.length - 1) {
      setDirection('next');
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex(prev => prev + 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setIsTransitioning(false);
      }, 500);
    }
  };
  
  const handlePrev = () => {
    if (currentIndex > 0) {
      setDirection('prev');
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex(prev => prev - 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setIsTransitioning(false);
      }, 500);
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [project]);
  
  
  
  return (
    <>

      {/* <div className={`project-transition-wrapper ${isTransitioning ? 'fade-out' : 'fade-in'}`}> */}
      {/* <div className={`project-transition-wrapper ${isTransitioning ? (direction === 'next' ? 'slide-left' : 'slide-right') : 'slide-in'}`}> */}
      <div
  ref={wrapperRef}
  className={`project-transition-wrapper ${isTransitioning ? (direction === 'next' ? 'slide-left' : 'slide-right') : 'slide-in'}`}
>

        <Spacing lg="70" md="70" />
        <Spacing lg="140" md="80" />
        <SectionHeadingStyle3 title={project.title} subTitle={project.subTitle} />
        <Spacing lg="75" md="60" />
        <div className="container">
          <div className="cs_portfolio_details">
            <img src={project.mainImage} alt="Thumb" />
            <Spacing lg="100" md="40" />
            <div className="cs_portfolio_details_in">
              <ul className="cs_portfolio_details_info cs_mp0">
                <li>
                  <h3 className="cs_fs_21 mb-0 cs_semibold">Client:</h3>
                  <p className="mb-0">{project.client}</p>
                </li>
                <li>
                  <h3 className="cs_fs_21 mb-0 cs_semibold">Location:</h3>
                  <p className="mb-0">{project.location}</p>
                </li>
                <li>
                  <h3 className="cs_fs_21 mb-0 cs_semibold">Work:</h3>
                  <p className="mb-0">{project.budget}</p>
                </li>
                <li>
                  <h3 className="cs_fs_21 mb-0 cs_semibold">Project Duration:</h3>
                  <p className="mb-0">{project.date}</p>
                </li>
              </ul>
              <div className="cs_portfolio_details_right">
                <h2>Project Summary</h2>
                {project.summary.map((text, i) => (
                  <p key={i}>{text}</p>
                ))}
              </div>
            </div>
            <Spacing lg="115" md="60" />
            <div className="cs_portfolio_details_gallery">
              {project.gallery.map((img, i) => (
                <div key={i}>
                  <img src={img} alt={`Gallery ${i + 1}`} />
                </div>
              ))}
            </div>
          </div>
          <Spacing lg="90" md="60" />

          <div className="cs_page_navigation cs_center">
            <div>
              <button
                type="button"
                onClick={handlePrev}
                className={`cs_text_btn cs_type1 ${currentIndex === 0 ? 'cs_disabled' : ''}`}
                disabled={currentIndex === 0}
                style={{ all: 'unset', cursor: currentIndex === 0 ? 'not-allowed' : 'pointer' }}
              >
                <Icon icon="cil:arrow-left" className="cs_fs_21" />
                <span>Prev Project</span>
              </button>
            </div>
            <div>
              <button
                type="button"
                onClick={handleNext}
                className={`cs_text_btn ${currentIndex === brandData.length - 1 ? 'cs_disabled' : ''}`}
                disabled={currentIndex === brandData.length - 1}
                style={{ all: 'unset', cursor: currentIndex === brandData.length - 1 ? 'not-allowed' : 'pointer' }}
              >
                <span>Next Project</span>
                <Icon icon="cil:arrow-right" className="cs_fs_21" />
              </button>
            </div>
          </div>

        </div>
        <Spacing lg="150" md="80" />
      </div>

      <style jsx>{`
                .project-transition-wrapper {
            transition: opacity 0.4s ease-in-out;
          }

          .fade-out {
            opacity: 0;
            pointer-events: none;
          }

          .fade-in {
            opacity: 1;
          }

                    .project-transition-wrapper {
            transition: all 0.5s ease-in-out;
            opacity: 1;
            transform: translateX(0);
          }

          .slide-left {
            opacity: 0;
            transform: translateX(-50px);
          }

          .slide-right {
            opacity: 0;
            transform: translateX(50px);
          }

          .slide-in {
            opacity: 1;
            transform: translateX(0);
          }


      `}</style>

    </>


  );
}